import axios from "axios";

export type VatTypeCode =
  | "0"
  | "5"
  | "7"
  | "10"
  | "22"
  | "105"
  | "107"
  | "110"
  | "122";

export interface PaymentSettings {
  id?: number;
  bankPaymentsEnabled?: boolean;
  apiToken?: string;
  tokenExpiresAt?: string;
  customerCode?: string;
  merchantId?: string;
  taxation?: number | string;
  clientId?: string;
  webhookUrl?: string;
  paymentServerUrl?: string;
  successRedirectUrl?: string;
  failRedirectUrl?: string;
  updatedAt?: string;
  updatedBy?: number;
}

const normalizeSettings = (
  data: PaymentSettings | PaymentSettings[] | null | undefined
): PaymentSettings | null => {
  if (Array.isArray(data)) {
    return data[0] ?? null;
  }
  if (data && typeof data === "object") {
    return data;
  }
  return null;
};

export const fetchPaymentSettings = (): Promise<PaymentSettings | null> =>
  axios
    .get<PaymentSettings | PaymentSettings[]>("/admin/payment-settings")
    .then((resp) => normalizeSettings(resp.data))
    .catch((err: unknown) => {
      if (axios.isAxiosError(err) && err.response?.status === 404) {
        return null;
      }
      throw err;
    });

export const createPaymentSettings = (
  payload: PaymentSettings
): Promise<PaymentSettings> =>
  axios
    .post<PaymentSettings>("/admin/payment-settings", payload)
    .then((resp) => resp.data);

export const updatePaymentSettings = (
  payload: PaymentSettings
): Promise<PaymentSettings> =>
  axios
    .put<PaymentSettings>("/admin/payment-settings", payload)
    .then((resp) => resp.data);
